import React from 'react';

/**
 * AboutSection - Grid Stabilizing Data Flexibility
 * Exact content from original index.html
 */
function AboutSection() {
  return (
    <section id="about">
      <div className="container">
        {/* About */}
        <div className="row align-items-center wow fadeIn">
          <div className="col-md-6">
            <div className="title">
              <h6 className="third-color mb-3">Grid Stabilizing Data Flexibility</h6>
              <h2>Grid-Integrated Infrastructure for the Next Generation of Energy & Compute</h2>
            </div>
          </div>
          <div className="col-md-6 mb-4">
            <p>
              These 50-200 MW projects are privately financed, utility-directed datacenters engineered for
              real-time grid responsiveness. They act as flexible load resources—consuming surplus
              generation during off-peak hours and instantly curtailing when the grid is stressed.
              <br /><br />
              Built to align with reserve margin standards and operational efficiency goals, this model 
              strengthens system reliability while enabling cost-effective monetization of otherwise 
              stranded energy.
            </p>
          </div>
        </div>

        {/* Features */}
        <div className="row">
          <div className="col-md-4 wow fadeInLeft">
            <div className="feature-box">
              <span className="item-number gradient-text1">
                01.
              </span>
              <h6 className="mb-4">Grid Controlled</h6>
              <p>
                A 100% curtailable datacenter load built to support utility dispatch needs, helping 
                absorb excess generation and minimize cycling of thermal assets.
              </p>
            </div>
          </div>
          <div className="col-md-4 wow fadeInUp">
            <div className="feature-box">
              <span className="item-number gradient-text1">
                02.
              </span>
              <h6 className="mb-4">Minimized Capital</h6>
              <p>
                Privately funded infrastructure deployed on utility terms. The host utility retains 
                curtailment rights and option of public buyout following a pilot term.
              </p>
            </div>
          </div>
          <div className="col-md-4 wow fadeInRight">
            <div className="feature-box">
              <span className="item-number gradient-text1">
                03.
              </span>
              <h6 className="mb-4">Aligned & Scalable</h6>
              <p>
                Qualifies as a dispatchable capacity resource under planning reserve requirements, 
                with modular scaling potential and fast curtailment response.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;